import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { commandWorkspaceCollaboratorSummary } from '../actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { workspaceId, accountOrTeamId, collaboratorType } = action;

  const workspacePermissionRevoke = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PERMISSION_REVOKE,
    workspaceId,
    [`${collaboratorType}Id`]: accountOrTeamId,
  });

  if (workspacePermissionRevoke.type === constants.RTM_WORKSPACE_PERMISSION_REVOKE_OK) {
    yield put(commandWorkspaceCollaboratorSummary(workspaceId));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: workspacePermissionRevoke.message || <FormattedMessage {...messages.permissionRevokeError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_REVOKE_PERMISSION, catchErrors, sendRequest, connection);
}
